import cx from 'classnames';
import { RichUtils } from 'draft-js';

import Icon from 'components/shared/Icon';
import BoldIcon from 'components/shared/Icon/icons/BolderText';
import ItalicIcon from 'components/shared/Icon/icons/ItalicText';
import UnderlineIcon from 'components/shared/Icon/icons/UnderlineText';
import { useWysiwygContext } from 'components/shared/Wysiwyg/Wysiwyg.contex';

import { BaseItemButton } from '../Base';
import s from './TextStyle.module.css';

type Props = {
  type: 'BOLD' | 'UNDERLINE' | 'ITALIC';
};

const TextStyle = (props: Props) => {
  const { editor } = useWysiwygContext();
  const icon = (() => {
    switch (props.type) {
      case 'BOLD':
        return BoldIcon;
      case 'UNDERLINE':
        return UnderlineIcon;
      case 'ITALIC':
        return ItalicIcon;
    }
  })();

  const isActive = editor.editorState.getCurrentInlineStyle().has(props.type);

  const onClick = () => {
    editor.handleChange(RichUtils.toggleInlineStyle(editor.editorState, props.type));
  };

  return (
    <BaseItemButton onClick={onClick}>
      <Icon width="18" height="18" component={icon} className={cx(isActive && s.active)} />
    </BaseItemButton>
  );
};

export const Bold = () => <TextStyle type="BOLD" />;
export const Underline = () => <TextStyle type="UNDERLINE" />;
export const Italic = () => <TextStyle type="ITALIC" />;
